import {
  Box,
  Button,
  CircularProgress,
  Grid2 as Grid,
  Icon,
  InputLabel,
  Typography,
} from "@mui/material";
import { handleRetrieveForumCategories } from "../../../redux/public-slices/forum.slice";
import { handleCreateForum } from "../../../redux/user-slices/forum.slice";
import { createForumSchema } from "../../../utils/velidations";
import { useDispatch, useSelector } from "react-redux";
import { checkUserType } from "../../../utils/helper";
import { useEffect, useRef, useState } from "react";
import SkeletonImage from "../../ui/SkeletonImage";
import InputFieldB from "../../ui/InputFieldB";
import SelectInput from "../../ui/SelectInput";
import { useNavigate } from "react-router-dom";
import Icons from "../../../assets/js/Icons";
import "ckeditor5/ckeditor5.css";

function AddForum() {
  const files = useRef("");
  const formRef = useRef("");
  const navigate = useNavigate();
  const categoryRef = useRef("");
  const dispatch = useDispatch();
  const userType = checkUserType();
  const [image, setImage] = useState(null);
  const [categories, setCategories] = useState([]);
  const [helperText, setHelperText] = useState([]);
  const { loadings } = useSelector((state) => state.otherSlice);

  // Handle get all blog categories
  const handleretrieveAll = async () => {
    const { records } = await dispatch(
      handleRetrieveForumCategories({ limit: 100 })
    ).unwrap();
    setCategories(records);
  };

  // Handle image preview
  const handleImagePreview = (e) => {
    files.current = Array.from(e.target.files);
    const views = files.current?.map((img) => URL.createObjectURL(img));
    setImage(views);
  };

  // Handle create blog
  const handleSubmit = (isDraft) => {
    const form = formRef.current;
    const formData = Object.fromEntries(new FormData(form));
    formData.banner = files?.current || [];
    formData.categoryId = categoryRef?.current?.value?._id || "";

    const result = createForumSchema.safeParse({ ...formData, isDraft });
    if (!result.success) {
      const groupedErrors = {};
      result.error.issues.forEach((issue) => {
        const key = issue.path[0];
        if (!groupedErrors[key]) groupedErrors[key] = [];
        groupedErrors[key].push(issue.message);
      });
      setHelperText(groupedErrors);
      return;
    }

    setHelperText([]);

    dispatch(handleCreateForum({ data: formData, isDraft }))
      .unwrap()
      .then(() => {
        setTimeout(() => {
          navigate(`/${userType}/profile/all-forum`);
        }, 500);
      })
      .catch(() => {});
  };

  useEffect(() => {
    handleretrieveAll();
    // eslint-disable-next-line
  }, []);

  return (
    <Box
      sx={{
        p: 3,
        height: "100%",
        bgcolor: "white",
        borderRadius: "8px",
      }}
    >
      <Typography variant="dashboardSectionTitle">Add new forum</Typography>

      <Box className="page-content">
        <Grid container spacing={3} component="form" ref={formRef}>
          <Grid size={{ xs: 12, xl: 6 }}>
            <SelectInput
              label="Category *"
              renderValueKey="name"
              inputRef={categoryRef}
              options={categories || []}
              placeholder="Enter Question"
              selectLabel="Select Category"
              isError={Boolean(helperText?.categoryId)}
            />
            {helperText?.categoryId?.[0] && (
              <Typography mt={0.5} fontSize="14px" color="error.main">
                {helperText?.categoryId?.[0]}
              </Typography>
            )}
          </Grid>
          <Grid size={{ xs: 12, xl: 6 }}>
            <InputFieldB
              name="title"
              label="Title *"
              variant="outlined"
              helperText={helperText}
              placeholder="Enter Title"
              labelvariant="InputLabelA"
            />
          </Grid>
          <Grid size={12}>
            <InputLabel
              sx={{
                mb: 0,
                height: "100%",
                maxHeight: 300,
                borderRadius: "8px",
                border: "1px dashed",
                placeContent: "center",
                borderColor: "primary.main",
                display: image ? "block" : "grid",
              }}
            >
              {image ? (
                <SkeletonImage
                  sx={{ objectFit: "contain" }}
                  src={image || null}
                />
              ) : (
                <>
                  <Icon
                    sx={{
                      fontSize: "100px",
                      color: "other.color2",
                      m: "auto",
                      svg: { display: "block" },
                    }}
                  >
                    <Icons.ImageSolid />
                  </Icon>
                  <Typography mb={1.5} color="other.color2">
                    Upload image
                  </Typography>
                </>
              )}
              <input
                style={{ display: "none" }}
                onChange={handleImagePreview}
                accept="image/*"
                type="file"
              />
              {/*  */}
            </InputLabel>
            {helperText?.banner?.[0] && (
              <Typography mt={0.5} fontSize="14px" color="error.main">
                {helperText?.banner?.[0]}
              </Typography>
            )}
          </Grid>
          <Grid size={12}>
            <InputFieldB
              type="textarea"
              label="content *"
              name="description"
              variant="outlined"
              helperText={helperText}
              labelvariant="InputLabelA"
              placeholder="Enter content"
            />
          </Grid>
          <Grid>
            <Box
              sx={{
                gap: 1,
                // maxWidth: 600,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Button
                type="button"
                variant="contained"
                sx={{
                  px: 3,
                  justifyContent: "center",
                }}
                endIcon={
                  loadings?.create_publish && (
                    <CircularProgress size={22} color="text" thickness={6} />
                  )
                }
                onClick={() => {
                  handleSubmit(false);
                }}
              >
                Submit
              </Button>
              <Button
                type="button"
                variant="contained"
                sx={{
                  ppx: 3,
                  // minWidth: "150px",
                  justifyContent: "center",
                }}
                endIcon={
                  loadings?.create_draft && (
                    <CircularProgress size={22} color="text" thickness={6} />
                  )
                }
                onClick={() => {
                  handleSubmit(true);
                }}
              >
                Save Draft
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default AddForum;
